export default __webpack_public_path__ + "static/media/Lip_3_M.2ae8b43d.svg";